import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Roles } from "app/model/rol";
import { User } from "app/model/user";
import { urls } from "assets/url/urls";
import { jwtDecode } from "jwt-decode";

@Injectable({
    providedIn: 'root'
})
export class LoginService {
    private TENANT = urls.tenant;

    headers = { 'X-TENANT-ID': this.TENANT };

    /**
     * Constuctor
     */
    constructor(private http: HttpClient) {

    }

    // Call generate token
    public generateToken(loginData: any) {
        const headers = this.headers;
        return this.http.post(`${urls.baseUrl}/generate-token`, loginData, { headers });
    }

    // New session with token
    public loginUser(token: string) {
        sessionStorage.removeItem('token');
        sessionStorage.setItem('token', token);
    }

    public isLoggedIn() {
        const tokenStr = sessionStorage.getItem('token');
        if (tokenStr == null || tokenStr == undefined || tokenStr == '') {
            return false;
        } else {
            if (jwtDecode(tokenStr).exp > Date.now() / 1000) {

                return true;
            } else {
                return false;
            }
        }
    }

    // Close session and delete tolen
    public logout() {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');
        return true;
    }

    // Get token
    public getToken() {
        return sessionStorage.getItem('token');
    }

    // Save user
    public setUser(user: User) {

        sessionStorage.removeItem('user');
        sessionStorage.setItem('user', JSON.stringify(user));
    }

    // Get user
    public getUser() {
        const userStr = sessionStorage.getItem('user');
        if (userStr !== null || userStr !== undefined || userStr !== '') {
            return JSON.parse(userStr);
        } else {
            this.logout();
            return null;
        }
    }

    // Get User roles
    public getUserRoles(): string[] {
        const user = this.getUser()

        return user.userRoles.map(item => item.name)
    }

    // Get current user
    public getCurrentUser(token: string) {
        const headers = new HttpHeaders({
            'X-TENANT-ID': this.TENANT,
            'Authorization': 'Bearer ' + token
        });

        return this.http.get(`${urls.baseUrl}/userCurrent`, { headers });
    }

    public getNewPassword(email: String) {
        const headers = this.headers;
        return this.http.post(`${urls.baseUrl}/newPassword`, { email: email }, { headers });
    }

    public isAdmin(): boolean {
        return this.getUserRoles().includes(Roles.ADMIN_ROLE)
    }

    public isLeader(): boolean {
        return this.getUserRoles().includes(Roles.LEADER_ROLE)
    }

    public isSuperLeader(): boolean {
        return this.getUserRoles().includes(Roles.SUPER_LEADER_ROLE)
    }

    public isSuper(): boolean {
        return this.isAdmin() || this.isLeader() || this.isSuperLeader()
    }
}
